// extracted by mini-css-extract-plugin
export default {"scope":"nFUxy","meta":"u7eCD","model":"ZE5Za","record":"_4wUDi","link":"DWadI","time":"z84Iw"};